namespace Dashboard {
    enum Notification {
        CreateProfile= 0,
        TravelChange= 1,
        CsrQuestion= 2,
        DuePayment= 3,
        PassengerApi= 4,
        NewsletterSignup= 5,
        HotelReview= 6,
        PayAtHotel= 7,
        OutboundFlightCheckin= 8,
        InboundFlightCheckin= 9
    };

    export interface IDashboardNotificationService {
        getNotifications(): ng.IPromise<INotification[]>;
        getNotificationLinks(): any;
        formatNotification(noti: INotification): string;
        notificationClicked(noti: INotification): void;
    }

    export class DashboardNotificationService implements IDashboardNotificationService {
        private _notificationTypes: any = {
            1: () => _.identity('NOTICSRCHANGE'),
            2: () => _.identity('NOTICSR'),
            3: n => this._getPaymentDueString(n), //pamentDue String changes depending upon booking type and dueDate
            4: () => _.identity('NOTIAPI'),
            6: () => _.identity('NOTIREVIEW'),
            10: () => _.identity('NOTICREATEPROFILE')

        };

        private _notificationActionTypes: any = {
            1: 'NOTICSRCHANGE_ACTION',
            2: 'NOTICSR_ACTION',
            3: 'NOTIPAYMENT_DUE_ACTION',
            4: 'NOTIAPI_ACTION',
            6: 'NOTIREVIEW_ACTION',
            10: 'NOTICREATEPROFILE_ACTION'
        };

        private _paymentDueType: any = {
            hotelDue: 'NOTIDUEHOTEL',
            hotelOverDue: 'NOTIOVERDUEHOTEL',
            flightDue: 'NOTIDUEFLIGHT',
            flightOverDue: 'NOTIOVERDUEFLIGHT',
            transferDue: 'NOTIDUETRANSFER',
            transferOverDue: 'NOTIOVERDUETRANSFER'
        };

        private _desktopUrl: string = 'desktop-url/{{SiteId}}/{{BookingId}}/{{LastName}}';

        getNotificationLinks: any = () => this.notificationLink.get();
        //private _notificationLinks: _.Dictionary<T> = {1:'a'};

        constructor(
            private $http: ng.IHttpService,
            private $location: any,
            private $interpolate: any,
            private $filter: ng.IFilterService,
            private dateUtil: any,
            private resourceService: Core.ResourceService,
            private dashboardBookingService: any,
            private notificationLink: any) { }


        getNotifications(): ng.IPromise<INotification[]> {
            return this.$http.post('/api2/bookings/manage/getbookingnotifications',
            {
                Culture: TRPCONFIG.Domain.CultureCode,
                DomainId: TRPCONFIG.Domain.DomainId
            },
            { ignoreErrors: true }).then(result => this._postProcess(result));
        }

        //getNotificationLinks() {
        //    return angular.copy(this._notificationLinks);
        //}

        notificationClicked(notification: INotification): void {
            let path = this._translateActionLink(this.getNotificationLinks()[notification.Type], notification);
            this.$location.url(path);
        }

        formatNotification(noti: INotification): string{
            let resourceVal:string = this.resourceService.get(noti.templateString);
            let bookingType:string =
                this.resourceService.get(this.dashboardBookingService.calculateType(noti.BookingType).code);

            switch (noti.Type) {
                case Notification.TravelChange:
                    return String.format(resourceVal, bookingType, noti.DestinationName);
                case Notification.CsrQuestion:
                    return String.format(resourceVal, noti.AgentName, bookingType, noti.DestinationName);
                case Notification.DuePayment:
                    let dueDateText = this.dueDateText(noti);
                    return String.format(resourceVal, this.$filter('customCurrency')(noti.Amount, noti.CurrencyCode),
                        noti.DestinationName, dueDateText);
                case Notification.PassengerApi:
                    return String.format(resourceVal, noti.DestinationName);
                case Notification.HotelReview:
                    return String.format(resourceVal, noti.DestinationName);
            }

            return resourceVal;
        }

        dueDateText(noti: INotification): string {
            let days = this.dateUtil.dayDiff(this.dateUtil.todayPlus(0, 0, true), noti.DueDate) - 1;

            if (days > 1) {
                let daysWithin = this.resourceService.get('DAYSWITHIN');
                return String.format(daysWithin, days);
            }
            if (days === 1) {
                return this.resourceService.get('TOMORROW');
            }
            if (days === 0) {
                return this.resourceService.get('TODAY');
            }

            return '';
        }

        private _translateActionLink(link: string, booking:any) {
            return link ? this.$interpolate(link)(booking) : '';
        }

        private _getPaymentDueString(n:INotification) {
            let accommodationBooking = 8;
            let transferBooking = 32;
            let dayDiff = this.dateUtil.compareDates(this.dateUtil.todayPlus(1), n.DueDate);
            if (n.BookingType === accommodationBooking) {
                return (dayDiff === 1)
                    ? this._paymentDueType.hotelOverDue : this._paymentDueType.hotelDue;
            }
            if (n.BookingType === transferBooking) {
                return (dayDiff === 1)
                    ? this._paymentDueType.transferOverDue : this._paymentDueType.transferDue;
            }
            return (dayDiff === 1)
                ? this._paymentDueType.flightOverDue : this._paymentDueType.flightDue;
        }

        private _postProcess(result: any): INotification[] {
            let notifications = result.data.Notifications;
            let validNoti:any = [];
            _.each(notifications, (n: INotification) => {
                if (this._notificationTypes[n.Type]) {
                    n.templateString = this._notificationTypes[n.Type](n);
                    n.actionString = this.resourceService.get(this._notificationActionTypes[n.Type]);
                    validNoti.push(n);
                }
            });
            return validNoti;
        }
    }

    export interface INotification {
        Type: number;
        BookingType: number;
        SiteId: string;
        BookingId: number;
        Amount: number;
        DueDate: string;
        LastName: string;
        CurrencySymbol: string;
        CurrencyCode: string;
        TaskId: number;
        AgentName: string;
        DestinationName: string;
        StartDate: string;
        HasFuturePayments: boolean;
        templateString: string;
        actionString: string;
    }
    angular
        .module('dashboard')
        .service('dashboardNotificationService', DashboardNotificationService);

}
